function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { sdkLogger } from '../../../logger';
import { isVersionCompliant } from '../shaka-version-utils';
import { PsfErrorCode } from './error-codes';
import { ContentType } from './psf-utils';
import { PSF_MIME_TYPE } from './types';
/**
 * Implementation of shaka manifest parser to work with internal PSF format.
 * @implements {shaka.extern.ManifestParser}
 */ export var PsfParser = /*#__PURE__*/ function() {
    "use strict";
    function PsfParser() {
        _class_call_check(this, PsfParser);
        _define_property(this, "logger", sdkLogger.withContext('PsfParser'));
        _define_property(this, "config", null);
        _define_property(this, "playerInterface", null);
        _define_property(this, "periodCombiner", null);
        _define_property(this, "thumbnailMap", new Map());
        _define_property(this, "manifest", null);
        _define_property(this, "globalId", 1);
    }
    _create_class(PsfParser, [
        {
            key: "configure",
            value: /** @override */ function configure(config) {
                this.config = config;
            }
        },
        {
            key: "start",
            value: /** @override */ function start(uri, playerInterface) {
                var _this = this;
                return _async_to_generator(function() {
                    var startTime, response, downloadEndTime, parseStartTime, endTime;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                startTime = Date.now();
                                _this.playerInterface = playerInterface;
                                _this.periodCombiner = new shaka.util.PeriodCombiner();
                                _this.periodCombiner.setUseStreamOnce(true);
                                return [
                                    4,
                                    _this.requestManifest(uri)
                                ];
                            case 1:
                                response = _state.sent();
                                downloadEndTime = Date.now();
                                if (!_this.playerInterface) {
                                    throw new shaka.util.Error(shaka.util.Error.Severity.CRITICAL, shaka.util.Error.Category.PLAYER, shaka.util.Error.Code.OPERATION_ABORTED);
                                }
                                parseStartTime = Date.now();
                                return [
                                    4,
                                    _this.buildManifest(response)
                                ];
                            case 2:
                                _this.manifest = _state.sent();
                                endTime = Date.now();
                                _this.manifest.lowestVideoBitrate = _this.getLowestVideoBitrate(_this.manifest.variants);
                                _this.manifest.manifestTimeSeconds = (endTime - startTime) / 1000;
                                _this.manifest.manifestDownloadTimeSeconds = (downloadEndTime - startTime) / 1000;
                                _this.manifest.manifestParseTimeSeconds = (endTime - parseStartTime) / 1000;
                                return [
                                    2,
                                    _this.manifest
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stop",
            value: /** @override */ function stop() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_periodCombiner;
                    return _ts_generator(this, function(_state) {
                        (_this_periodCombiner = _this.periodCombiner) === null || _this_periodCombiner === void 0 ? void 0 : _this_periodCombiner.release();
                        _this.periodCombiner = null;
                        _this.playerInterface = null;
                        _this.config = null;
                        _this.manifest = null;
                        _this.thumbnailMap.clear();
                        _this.globalId = 1;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getThumbnailStream",
            value: /** @override */ function getThumbnailStream(thumbnailVariant) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_manifest, stream, _this_getTileDimensions, columns, rows, thumbnailSegments, _stream_segmentIndex, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ref, _stream_tilesLayout, thumbnailStream, _this_thumbnailMap_get;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.thumbnailMap.has(thumbnailVariant.id)) return [
                                    3,
                                    3
                                ];
                                stream = (_this_manifest = _this.manifest) === null || _this_manifest === void 0 ? void 0 : _this_manifest.imageStreams.find(function(stream) {
                                    return stream.id.toString() === thumbnailVariant.id;
                                });
                                if (!stream) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                _this_getTileDimensions = _sliced_to_array(_this.getTileDimensions(stream.tilesLayout), 2), columns = _this_getTileDimensions[0], rows = _this_getTileDimensions[1];
                                if (!!stream.segmentIndex) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    stream.createSegmentIndex()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                thumbnailSegments = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = ((_stream_segmentIndex = stream.segmentIndex) !== null && _stream_segmentIndex !== void 0 ? _stream_segmentIndex : [])[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        ref = _step.value;
                                        thumbnailSegments.push({
                                            startPosition: ref.getStartTime(),
                                            duration: ref.getEndTime() - ref.getStartTime(),
                                            tileUrl: ref.getUris()[0]
                                        });
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                thumbnailStream = _object_spread_props(_object_spread({}, thumbnailVariant), {
                                    maxHorizontalThumbnailCount: columns,
                                    maxVerticalThumbnailCount: rows,
                                    tileCount: (_stream_tilesLayout = stream.tilesLayout) !== null && _stream_tilesLayout !== void 0 ? _stream_tilesLayout : '',
                                    tileWidth: stream.width,
                                    tileHeight: stream.height,
                                    maxSegmentDuration: stream.maxSegmentDuration,
                                    thumbnailDuration: stream.maxSegmentDuration / (columns * rows),
                                    thumbnailSegments: thumbnailSegments
                                });
                                _this.thumbnailMap.set(thumbnailVariant.id, thumbnailStream);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    (_this_thumbnailMap_get = _this.thumbnailMap.get(thumbnailVariant.id)) !== null && _this_thumbnailMap_get !== void 0 ? _this_thumbnailMap_get : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "update",
            value: /** @override */ function update() {}
        },
        {
            key: "onExpirationUpdated",
            value: // no-op
            /** @override */ function onExpirationUpdated(sessionId, expiration) {}
        },
        {
            key: "requestManifest",
            value: // no-op
            function requestManifest(uri) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_config, requestType, request, networkingEngine, response;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                requestType = shaka.net.NetworkingEngine.RequestType.MANIFEST;
                                request = shaka.net.NetworkingEngine.makeRequest([
                                    uri
                                ], (_this_config = _this.config) === null || _this_config === void 0 ? void 0 : _this_config.retryParameters);
                                networkingEngine = _this.playerInterface.networkingEngine;
                                return [
                                    4,
                                    networkingEngine.request(requestType, request).promise
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildManifest",
            value: function buildManifest(response) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_periodCombiner, _this_periodCombiner1, _this_periodCombiner2, _this_periodCombiner3, data, psf, periods, start, end, timeline, _this_periodCombiner_getVariants, _this_periodCombiner_getTextStreams, _this_periodCombiner_getImageStreams, _response_data_byteLength, manifest;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                data = shaka.util.StringUtils.fromUTF8(response.data);
                                try {
                                    psf = JSON.parse(data);
                                } catch (e) {
                                    _this.logger.warn('Could not parse PSF manifest', e);
                                    throw new shaka.util.Error(shaka.util.Error.Severity.CRITICAL, shaka.util.Error.Category.MANIFEST, PsfErrorCode.INVALID_JSON);
                                }
                                periods = _this.extractPeriods(psf);
                                start = Date.now();
                                return [
                                    4,
                                    (_this_periodCombiner = _this.periodCombiner) === null || _this_periodCombiner === void 0 ? void 0 : _this_periodCombiner.combinePeriods(periods, /* isDynamic= */ false)
                                ];
                            case 1:
                                _state.sent();
                                end = Date.now();
                                _this.logger.verbose('period combiner took', (end - start) / 1000);
                                timeline = new shaka.media.PresentationTimeline(/* presentationStartTime= */ null, /* presentationDelay= */ 0);
                                timeline.setDuration(psf.duration);
                                manifest = {
                                    presentationTimeline: timeline,
                                    minBufferTime: 0,
                                    variants: (_this_periodCombiner_getVariants = (_this_periodCombiner1 = _this.periodCombiner) === null || _this_periodCombiner1 === void 0 ? void 0 : _this_periodCombiner1.getVariants()) !== null && _this_periodCombiner_getVariants !== void 0 ? _this_periodCombiner_getVariants : [],
                                    textStreams: (_this_periodCombiner_getTextStreams = (_this_periodCombiner2 = _this.periodCombiner) === null || _this_periodCombiner2 === void 0 ? void 0 : _this_periodCombiner2.getTextStreams()) !== null && _this_periodCombiner_getTextStreams !== void 0 ? _this_periodCombiner_getTextStreams : [],
                                    imageStreams: (_this_periodCombiner_getImageStreams = (_this_periodCombiner3 = _this.periodCombiner) === null || _this_periodCombiner3 === void 0 ? void 0 : _this_periodCombiner3.getImageStreams()) !== null && _this_periodCombiner_getImageStreams !== void 0 ? _this_periodCombiner_getImageStreams : [],
                                    sequenceMode: false,
                                    offlineSessionIds: [],
                                    lowestVideoBitrate: 0,
                                    sizeBytes: (_response_data_byteLength = response.data.byteLength) !== null && _response_data_byteLength !== void 0 ? _response_data_byteLength : 0,
                                    gapCount: 0,
                                    periodCount: periods.length,
                                    manifestTimeSeconds: NaN,
                                    manifestDownloadTimeSeconds: NaN,
                                    manifestParseTimeSeconds: NaN,
                                    thumbnailVariants: []
                                };
                                // thumbnail variants API is not available anymore on v4.2.12 so omit preparing
                                // related objects.
                                if (shaka.Player.version.startsWith('v3.3.10')) {
                                    manifest.thumbnailVariants = manifest.imageStreams.map(function(stream) {
                                        var _this_getTileDimensions = _sliced_to_array(_this.getTileDimensions(stream.tilesLayout), 2), columns = _this_getTileDimensions[0], rows = _this_getTileDimensions[1];
                                        var _stream_bandwidth;
                                        return {
                                            id: stream.id.toString(),
                                            bandwidth: (_stream_bandwidth = stream.bandwidth) !== null && _stream_bandwidth !== void 0 ? _stream_bandwidth : 0,
                                            thumbnailWidth: columns > 0 ? stream.width / columns : 0,
                                            thumbnailHeight: rows > 0 ? stream.height / rows : 0
                                        };
                                    });
                                }
                                return [
                                    2,
                                    manifest
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "extractPeriods",
            value: function extractPeriods(psf) {
                var drmInfos = this.extractDrmInfos(psf.drmInfo);
                var outputList = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = psf.periods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var period = _step.value;
                        var _this_config, _this_config1, _this_config2, _this_config3;
                        var output = {
                            id: period.id,
                            audioStreams: [],
                            videoStreams: [],
                            textStreams: [],
                            imageStreams: []
                        };
                        var baseUrl = period.baseUrl || psf.baseUrl;
                        if (!((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.disableAudio)) {
                            var _period_audio;
                            output.audioStreams = this.parseStreams((_period_audio = period.audio) !== null && _period_audio !== void 0 ? _period_audio : [], drmInfos, period.timelines, ContentType.AUDIO, baseUrl, period.start, period.duration);
                        }
                        if (!((_this_config1 = this.config) === null || _this_config1 === void 0 ? void 0 : _this_config1.disableVideo)) {
                            var _period_video;
                            output.videoStreams = this.parseStreams((_period_video = period.video) !== null && _period_video !== void 0 ? _period_video : [], drmInfos, period.timelines, ContentType.VIDEO, baseUrl, period.start, period.duration);
                        }
                        if (!((_this_config2 = this.config) === null || _this_config2 === void 0 ? void 0 : _this_config2.disableText)) {
                            var _period_text;
                            output.textStreams = this.parseStreams((_period_text = period.text) !== null && _period_text !== void 0 ? _period_text : [], drmInfos, period.timelines, ContentType.TEXT, baseUrl, period.start, period.duration);
                        }
                        if (!((_this_config3 = this.config) === null || _this_config3 === void 0 ? void 0 : _this_config3.disableThumbnails)) {
                            var _period_image;
                            output.imageStreams = this.parseStreams((_period_image = period.image) !== null && _period_image !== void 0 ? _period_image : [], drmInfos, period.timelines, ContentType.IMAGE, baseUrl, period.start, period.duration);
                        }
                        outputList.push(output);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return outputList;
            }
        },
        {
            key: "parseStreams",
            value: function parseStreams(representations, drmInfos, timelines, contentType, baseUrl, start, duration) {
                var outputStreams = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this, _loop = function() {
                        var representation = _step.value;
                        var drmInfo = null;
                        if (typeof representation.drmInfoId === 'number') {
                            if (!drmInfos.has(representation.drmInfoId)) {
                                var _this_playerInterface;
                                _this.logger.warn('drm info with given id cannot be found, dropping stream', representation);
                                (_this_playerInterface = _this.playerInterface) === null || _this_playerInterface === void 0 ? void 0 : _this_playerInterface.onError(new shaka.util.Error(shaka.util.Error.Severity.RECOVERABLE, shaka.util.Error.Category.MANIFEST, PsfErrorCode.MISSING_DRM_INFO));
                                return "continue";
                            }
                            drmInfo = drmInfos.get(representation.drmInfoId);
                        }
                        var timeline = void 0;
                        if (typeof representation.timelineId === 'number') {
                            timeline = timelines.find(function(timeline) {
                                return timeline.id === representation.timelineId;
                            });
                            if (!timeline) {
                                var _this_playerInterface1;
                                _this.logger.warn('timeline with given id cannot be found, dropping stream', representation);
                                (_this_playerInterface1 = _this.playerInterface) === null || _this_playerInterface1 === void 0 ? void 0 : _this_playerInterface1.onError(new shaka.util.Error(shaka.util.Error.Severity.RECOVERABLE, shaka.util.Error.Category.MANIFEST, PsfErrorCode.MISSING_TIMELINE));
                                return "continue";
                            }
                        }
                        var stream = _this.buildStream(representation, contentType, drmInfo, timeline, baseUrl, start, start + duration);
                        outputStreams.push(stream);
                    };
                    for(var _iterator = representations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return outputStreams;
            }
        },
        {
            key: "buildStream",
            value: function buildStream(representation, contentType, drmInfo, timeline, baseUrl, periodStart, periodEnd) {
                var kind = undefined;
                if (contentType === ContentType.TEXT) {
                    switch(representation.role){
                        case 'subtitle':
                        case 'caption':
                            kind = representation.role;
                            break;
                        default:
                            kind = 'subtitle';
                    }
                }
                var _representation_codecs, _drmInfo_keyIds, _representation_label, _representation_language, _representation_language1;
                var stream = {
                    audioSamplingRate: null,
                    bandwidth: representation.bandwidth,
                    channelsCount: representation.channelsCount,
                    closeSegmentIndex: function() {
                        if (stream.segmentIndex) {
                            stream.segmentIndex.release();
                            stream.segmentIndex = null;
                        }
                    },
                    closedCaptions: null,
                    codecs: (_representation_codecs = representation.codecs) !== null && _representation_codecs !== void 0 ? _representation_codecs : '',
                    createSegmentIndex: /*#__PURE__*/ _async_to_generator(function() {
                        var SegmentIndex;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        import('./segment-index')
                                    ];
                                case 1:
                                    // We cannot import SegmentIndex statically, as it's extending shaka class and shaka is attached to the window dynamically.
                                    SegmentIndex = _state.sent().SegmentIndex;
                                    stream.segmentIndex = new SegmentIndex(representation, periodStart, periodEnd, timeline, baseUrl, contentType, stream.mimeType);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    drmInfos: drmInfo ? [
                        drmInfo
                    ] : [],
                    emsgSchemeIdUris: null,
                    encrypted: !!drmInfo,
                    forced: representation.role === 'forced-subtitle',
                    id: this.globalId++,
                    keyIds: (_drmInfo_keyIds = drmInfo === null || drmInfo === void 0 ? void 0 : drmInfo.keyIds) !== null && _drmInfo_keyIds !== void 0 ? _drmInfo_keyIds : new Set(),
                    kind: kind,
                    label: (_representation_label = representation.label) !== null && _representation_label !== void 0 ? _representation_label : null,
                    language: shaka.util.LanguageUtils.normalize((_representation_language = representation.language) !== null && _representation_language !== void 0 ? _representation_language : ''),
                    originalLanguage: (_representation_language1 = representation.language) !== null && _representation_language1 !== void 0 ? _representation_language1 : null,
                    mimeType: this.determineMimeType(contentType, representation),
                    originalId: representation.id,
                    primary: representation.role === 'main',
                    roles: representation.role ? [
                        representation.role
                    ] : [],
                    segmentIndex: null,
                    spatialAudio: false,
                    trickModeVideo: null,
                    type: contentType,
                    frameRate: representation.frameRate,
                    width: representation.width,
                    height: representation.height,
                    tilesLayout: representation.dimension,
                    maxSegmentDuration: timeline ? typeof timeline.duration === 'number' ? timeline.duration / timeline.timescale : undefined : periodEnd
                };
                return stream;
            }
        },
        {
            key: "extractDrmInfos",
            value: function extractDrmInfos(drmInfos) {
                var map = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (drmInfos !== null && drmInfos !== void 0 ? drmInfos : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var drmInfo = _step.value;
                        if (drmInfo.wvPssh) {
                            var keyId = drmInfo.kid.replace(/-/g, '');
                            map.set(drmInfo.id, {
                                audioRobustness: '',
                                distinctiveIdentifierRequired: false,
                                initData: [
                                    {
                                        initData: shaka.util.Uint8ArrayUtils.fromBase64(drmInfo.wvPssh),
                                        initDataType: 'cenc',
                                        keyId: keyId
                                    }
                                ],
                                keyIds: new Set([
                                    keyId
                                ]),
                                keySystem: 'com.widevine.alpha',
                                licenseServerUri: '',
                                persistentStateRequired: false,
                                serverCertificate: null,
                                serverCertificateUri: '',
                                sessionType: '',
                                videoRobustness: ''
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return map;
            }
        },
        {
            key: "getLowestVideoBitrate",
            value: function getLowestVideoBitrate(variants) {
                var bitrate = Infinity;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var variant = _step.value;
                        var _variant_video;
                        var _variant_video_bandwidth;
                        bitrate = Math.min(bitrate, (_variant_video_bandwidth = (_variant_video = variant.video) === null || _variant_video === void 0 ? void 0 : _variant_video.bandwidth) !== null && _variant_video_bandwidth !== void 0 ? _variant_video_bandwidth : Infinity);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return isFinite(bitrate) ? bitrate : 0;
            }
        },
        {
            key: "determineMimeType",
            value: function determineMimeType(contentType, representation) {
                var fileExtension = representation.urlTemplate.substring(representation.urlTemplate.lastIndexOf('.') + 1);
                var mimeType = PsfParser.EXTENSIONS_TO_MIME_TYPES[contentType][fileExtension];
                if (!mimeType) {
                    this.logger.warn('Unknown MIME type for extension', contentType, fileExtension);
                }
                return mimeType !== null && mimeType !== void 0 ? mimeType : '';
            }
        },
        {
            key: "getTileDimensions",
            value: function getTileDimensions(tilesLayout) {
                if (!tilesLayout) {
                    return [
                        1,
                        1
                    ];
                }
                var match = /(\d+)x(\d+)/.exec(tilesLayout);
                if (!match) {
                    return [
                        1,
                        1
                    ];
                }
                return [
                    parseInt(match[1]),
                    parseInt(match[2])
                ];
            }
        }
    ], [
        {
            key: "registerParser",
            value: /**
     * A way to register PsfParser to shaka via MIME.
     * @returns {boolean} `true` if parser has been successfully registered, `false` otherwise
     */ function registerParser() {
                if (!isVersionCompliant(shaka.Player.version, PsfParser.MINIMUM_SHAKA_VERSION)) {
                    sdkLogger.warn('PSF parser cannot be registered');
                    return false;
                }
                shaka.media.ManifestParser.registerParserByMime(PSF_MIME_TYPE, function() {
                    return new PsfParser();
                });
                return true;
            }
        }
    ]);
    return PsfParser;
}();
_define_property(PsfParser, "MINIMUM_SHAKA_VERSION", 'v3.3.10-v48');
var _obj;
_define_property(PsfParser, "EXTENSIONS_TO_MIME_TYPES", (_obj = {}, _define_property(_obj, ContentType.VIDEO, {
    m4i: 'video/mp4',
    m4s: 'video/mp4',
    m4v: 'video/mp4',
    mp4: 'video/mp4'
}), _define_property(_obj, ContentType.AUDIO, {
    m4a: 'audio/mp4',
    m4i: 'audio/mp4',
    m4s: 'audio/mp4',
    mp4: 'audio/mp4'
}), _define_property(_obj, ContentType.TEXT, {
    vtt: 'text/vtt',
    webvtt: 'text/vtt'
}), _define_property(_obj, ContentType.IMAGE, {
    jpg: 'image/jpeg'
}), _obj));

//# sourceMappingURL=psf-parser.js.map